import React, { useState, useEffect } from "react";
import CInput from "../../../basecomp/components/CInput2";
import CButton from "../../../basecomp/components/CButton";
import CDropDown from "../../../basecomp/components/CDropDown";
import CTable from "../../../basecomp/components/CTable";
import CDialog from "../../../basecomp/components/CDialog";
import CMainGrid from "../../../basecomp/components/wrapper/CMainGrid";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MatProcessVM from "../viewmodel/MatProcessVM";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import InfoIcon from "@mui/icons-material/Info";
import EmailIcon from "@mui/icons-material/Email";
import SearchIcon from "@mui/icons-material/Search";
import ProcessingModal from "./ProcessingModal";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { ThemeProvider, createTheme, useTheme } from "@mui/material/styles";

import AxiosWrapper from "../../../basecomp/base/AxiosWrapper";
const { axiosGetCallWithToken } = AxiosWrapper;

const MatProcessView = () => {
  const {
    processInput,
    handleInputChange,
    handleInfoClick,
    handleBackButtonClick,
    buttonJson,
    handleButtonClick,
    dialogOpen,
    mpnDialogOpen,
    handleDialogClose,
    handleMpnDialogClose,
    tableActualData,
    tableRowData,
    tableHeadData,
    isProcessingModalOpen,
    handleModalClose,
    processingModalMessage,
    selectableDialogOpen,
    handleSelectableDialogClose,
    handleRowSelect,
    selectableTableData,
    selectedIntMaterial,
    hasValidated,
    resetValidation,
    mpnEmptyDialogOpen,
    handleMpnEmptyDialogClose,
    
  } = MatProcessVM();
  const typeOfRequest = processInput?.["type_of_request"]?.value;

  const [showReasonInput, setShowReasonInput] = React.useState(false);
  // Tracks whether the user has clicked Validate since the last input change

  // Wraps every input change to reset the validation flag

  // const handleInputChangeWithReset = (key) => (value) => {
  //   setHasValidated(false);
  //   handleInputChange(key)(value);
  // };

  // Define which fields actually require re-validation when changed
  const VALIDATION_SENSITIVE_FIELDS = new Set([
    "mpn_number",
    "type_of_request",
    "material_number",
    "plant",
    // add any other core fields that affect validation logic
  ]);

  const handleInputChangeWithReset = (key) => (value) => {
    // Only reset validation if a field that affects the validation outcome changes
    if (VALIDATION_SENSITIVE_FIELDS.has(key)) {
      resetValidation();
    }
    handleInputChange(key)(value);
  };

  useEffect(() => {
    const fontId = "lato-font-link";
    if (!document.getElementById(fontId)) {
      const link = document.createElement("link");
      link.id = fontId;
      link.href =
        "https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700;900&display=swap";
      link.rel = "stylesheet";
      document.head.appendChild(link);
    }
  }, []);

  const outerTheme = useTheme();
  const localTheme = createTheme(outerTheme, {
    typography: {
      ...outerTheme.typography,
      fontFamily: "Lato, sans-serif",
    },
  });

  const dialogContent = (
    <CTable
      cHeaderData={tableHeadData}
      cRowData={tableRowData}
      cActualData={tableActualData}
      cIsPagination={false}
      cSmallSize={false}
    />
  );

  const MpnDuplicateDialogContent = (
    <CTable
      cHeaderData={tableHeadData}
      cRowData={tableRowData}
      cActualData={tableActualData}
      cIsPagination={false}
      cSmallSize={false}
    />
  );

  const openGoogleSearch = async () => {
    const mpnValue = processInput.mpn_number.value;
    const mpnName = processInput.mpn_name.value;

    if (mpnName) {
      try {
        const response = await axiosGetCallWithToken(
          `/mct/getLinkByMpnName?mpn_name=${mpnName}`,
        );
        if (response.data && response.data.m_link) {
          const linkWithMpnValue = `${response.data.m_link}${mpnValue}`;
          window.open(linkWithMpnValue, "_blank");
          return;
        }
      } catch (error) {
        console.error("Error fetching link:", error);
      }
    }

    if (mpnValue && mpnName) {
      window.open(
        `https://www.google.com/search?q=${mpnName} ${mpnValue}`,
        "_blank",
      );
    } else if (mpnValue) {
      window.open(`https://www.google.com/search?q=${mpnValue}`, "_blank");
    } else if (mpnName) {
      window.open(`https://www.google.com/search?q=${mpnName}`, "_blank");
    }
  };

  const getEmailFromUsername = async (username) => {
    const response = await axiosGetCallWithToken(
      `/mct/getEmailFromUser?requester_name=${username}`,
    );
    return response.data;
  };

  const openOutlookEmail = async (userName) => {
    if (userName) {
      try {
        const data = await getEmailFromUsername(userName);
        if (data && data.email) {
          window.open(
            `https://outlook.office.com/mail/deeplink/compose?to=${encodeURIComponent(data.email)}`,
            "_blank",
          );
        } else {
          console.error("Email not found for the user.");
        }
      } catch (error) {
        console.error("Error fetching email:", error);
      }
    }
  };
  const renderReasonField = (key) => {
    const isDelete = processInput["type_of_request"].value === "DELETE";
    const isModify = processInput["type_of_request"].value === "MODIFY";

    if (!isDelete && !isModify) return null;

    if (isDelete || (isModify && !showReasonInput)) {
      return (
        <CDropDown
          cId="dd_reason"
          cHelperText="Select or type reason"
          cData={
            isDelete
              ? ["Mark for deletion", "Reactivation"]
              : [
                  "Update storage bin location",
                  "Update PO text",
                  "Update Short Description",
                  "Update long description",
                  "Change MRP data",
                  "Update item class",
                  "Other",
                ]
          }
          cOnChange={(selectedReason) => {
            // setHasValidated(false);
            if (selectedReason === "Other" && isModify) {
              setShowReasonInput(true);
              handleInputChange(key)("");
            } else {
              handleInputChange(key)(selectedReason);
            }
          }}
          cFullWidth={true}
          cDefaultValue={processInput[key].initialValue}
          cValue={processInput[key].value}
        />
      );
    }

    if (isModify && showReasonInput) {
      return (
        <Box sx={{ position: "relative" }}>
          <CInput
            cFullWidth={true}
            cOnChange={(value) => {
              resetValidation();
              handleInputChange(key)(value);
            }}
            cIsRequired={true}
            cValue={processInput[key].value}
            cHintText="Enter custom reason"
          />
          <IconButton
            onClick={() => {
              setShowReasonInput(false);
              // 
              resetValidation();
              handleInputChange(key)("");
            }}
            style={{
              position: "absolute",
              right: 0,
              top: "50%",
              transform: "translateY(-50%)",
            }}
          >
            ×
          </IconButton>
        </Box>
      );
    }

    return null;
  };

  

  return (
    <ThemeProvider theme={localTheme}>
      <CMainGrid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        xl={12}
        sx={{ margin: "6em 0.75em 1em" }}
      >
        <ProcessingModal
          isOpen={isProcessingModalOpen}
          onClose={handleModalClose}
          processingModalMessage={processingModalMessage}
        />
        <Paper
          elevation={0}
          sx={{
            borderRadius: "8px",
            border: "1px solid #dbe3ef",
            overflow: "hidden",
            boxShadow: "0 18px 45px rgba(15, 23, 42, 0.08)",
            backgroundColor: "#ffffff",
          }}
        >
          <Box
            sx={{
              px: { xs: 2, md: 3 },
              py: 2.5,
              background: "linear-gradient( #07bc0c 100%)",
              color: "#ffffff",
            }}
          >
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={2}
              alignItems={{ xs: "flex-start", sm: "center" }}
              justifyContent="space-between"
            >
              <Stack direction="row" spacing={1.5} alignItems="center">
                <FactCheckOutlinedIcon />
                <Box>
                  <Typography sx={{ fontSize: 22, fontWeight: 800 }}>
                    Material Request Process
                  </Typography>
                  <Typography sx={{ fontSize: 13, opacity: 0.86 }}>
                    Review request details, validate, then complete the
                    workflow.
                  </Typography>
                </Box>
              </Stack>
              <CButton
                cId="mct_backButton"
                cSrc={<ArrowBackIcon />}
                cText="Back"
                cTooltipText="Go back to previous page"
                cOnClick={() => handleBackButtonClick()}
              />
            </Stack>
          </Box>

          <Box sx={{ p: { xs: 2, md: 3 } }}>
            <Box
              sx={{
                mb: 2.5,
                p: { xs: 1.5, md: 2 },
                borderRadius: "8px",
                border: "1px solid #dbe3ef",
                background: "linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)",
              }}
            >
              <Stepper activeStep={hasValidated ? 1 : 0} alternativeLabel>
                {["Validate request", "Approve or reject"].map((label) => (
                  <Step key={label}>
                    <StepLabel
                      sx={{
                        ".MuiStepLabel-label": {
                          fontSize: 12,
                          fontWeight: 800,
                          color: "#475569",
                        },
                      }}
                    >
                      {label}
                    </StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Box>

            <CMainGrid container spacing={2}>
              {Object.keys(processInput).map((key) => (
                <CMainGrid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={4}
                  xl={4}
                  key={key}
                  marginTop={1}
                  marginBottom={1}
                >
                  {key === "mpn_number" ? (
                    <CInput
                      cFullWidth={true}
                      cOnChange={(value) =>
                        handleInputChangeWithReset(key)(value)
                      }
                      cDisabled={processInput[key].isDisabled}
                      cIsRequired={processInput[key].isRequired}
                      cValue={processInput[key].value}
                      cOtherType={processInput[key].otherType}
                      cOtherMsg={processInput[key].otherMsg}
                      cHintText={processInput[key].enter}
                      cInputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={openGoogleSearch}>
                              <SearchIcon />
                            </IconButton>
                            {processInput[key].tableViewData && (
                              <IconButton
                                onClick={() =>
                                  handleInfoClick(
                                    processInput[key].tableViewData,
                                  )
                                }
                              >
                                <InfoIcon />
                              </IconButton>
                            )}
                          </InputAdornment>
                        ),
                      }}
                    />
                  ) : key === "user_name" ? (
                    <CInput
                      cFullWidth={true}
                      cOnChange={(value) =>
                        handleInputChangeWithReset(key)(value)
                      }
                      cDisabled={processInput[key].isDisabled}
                      cIsRequired={processInput[key].isRequired}
                      cValue={processInput[key].value}
                      cHintText={processInput[key].enter}
                      cInputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() =>
                                openOutlookEmail(processInput[key].value)
                              }
                            >
                              <EmailIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  ) : key === "reason" &&
                    (processInput["type_of_request"].value === "DELETE" ||
                      processInput["type_of_request"].value === "MODIFY") ? (
                    renderReasonField(key)
                  ) : (
                    <CInput
                      cFullWidth={true}
                      cOnChange={(value) =>
                        handleInputChangeWithReset(key)(value)
                      }
                      cDisabled={processInput[key].isDisabled}
                      cIsRequired={processInput[key].isRequired}
                      cValue={processInput[key].value}
                      cOtherType={processInput[key].otherType}
                      cOtherMsg={processInput[key].otherMsg}
                      cHintText={processInput[key].enter}
                      cRows={processInput[key].isRows === true ? 5 : 1}
                      cInputProps={{
                        ...(processInput[key].tableViewData !== undefined && {
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() =>
                                  handleInfoClick(
                                    processInput[key].tableViewData,
                                  )
                                }
                              >
                                <InfoIcon />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }),
                      }}
                    />
                  )}
                </CMainGrid>
              ))}
            </CMainGrid>

            {/* Warning banner shown until the user validates */}
            {!hasValidated && (
              <Alert
                severity="warning"
                sx={{
                  mt: 2,
                  borderRadius: "8px",
                  border: "1px solid #fde68a",
                  backgroundColor: "#fffbeb",
                  color: "#92400e",
                  alignItems: "center",
                }}
              >
                ⚠️ Please click <strong>Validate</strong> before approving or
                rejecting the request.
              </Alert>
            )}

            <CMainGrid container spacing={2} marginTop={2} marginBottom={2}>
              {Object.keys(buttonJson).map((key) => {
                const isValidateButton = key === "validate";
                // Non-validate buttons stay disabled until Validate has been clicked
                const isDisabled =
                  buttonJson[key].isDisabled

                return (
                  <CMainGrid item xs={12} sm={6} md={6} lg={3} xl={3} key={key}>
                    <CButton
                      cText={buttonJson[key].text}
                      cTooltipText={
                        !isValidateButton && !hasValidated
                          ? "Please validate the data first"
                          : buttonJson[key].tooltipText
                      }
                      cOnClick={() => {
                        handleButtonClick(key, buttonJson[key].text);
                      }}
                      cFullWidth={true}
                      cDisabled={isDisabled}
                    />
                  </CMainGrid>
                );
              })}
            </CMainGrid>

            <CDialog
              cOpen={dialogOpen}
              cHandleClose={handleDialogClose}
              cTitle="Details"
              cDialogContent={dialogContent}
            />

            <CDialog
              cOpen={mpnDialogOpen}
              cHandleClose={handleMpnDialogClose}
              cTitle="Duplicate MPN Details"
              cDialogContent={MpnDuplicateDialogContent}
            />
           

            {typeOfRequest !== "COPY" &&<CDialog
              cOpen={selectableDialogOpen}
              cHandleClose={handleSelectableDialogClose}
              cTitle="Select Internal Material Number"
              cDialogContent={
                <div>
                  <p
                    style={{
                      marginBottom: "12px",
                      color: "#555",
                      fontSize: "14px",
                    }}
                  >
                    Select a row to populate the Internal Material Number field.
                  </p>
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      fontSize: "13px",
                    }}
                  >
                    <thead>
                      <tr
                        style={{ backgroundColor: "#3CB043", color: "white" }}
                      >
                        <th
                          scope="col"
                          style={{ padding: "10px 12px", width: "40px" }}
                        >
                          <span
                            style={{
                              position: "absolute",
                              width: "1px",
                              height: "1px",
                              padding: 0,
                              margin: "-1px",
                              overflow: "hidden",
                              clip: "rect(0,0,0,0)",
                              whiteSpace: "nowrap",
                              border: 0,
                            }}
                          >
                            Select
                          </span>
                        </th>
                        {selectableTableData?.tableHeadData?.map((col, i) => (
                          <th
                            key={i}
                            style={{
                              padding: "10px 12px",
                              textAlign: "left",
                              fontWeight: 600,
                            }}
                          >
                            {col.value}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {selectableTableData?.tableActualData?.map(
                        (row, rowIndex) => {
                          const rowValue = row[selectableTableData.selectKey];
                          const isSelected = selectedIntMaterial === rowValue;
                          return (
                            <tr
                              key={rowIndex}
                              onClick={() =>
                                handleRowSelect(row, selectableTableData)
                              }
                              style={{
                                cursor: "pointer",
                                backgroundColor: isSelected
                                  ? "#c8e6c9"
                                  : rowIndex % 2 === 0
                                    ? "#f5f5f5"
                                    : "#fff",
                                borderBottom: "1px solid #e0e0e0",
                                transition: "background-color 0.2s",
                              }}
                              onMouseEnter={(e) => {
                                if (!isSelected)
                                  e.currentTarget.style.backgroundColor =
                                    "#e3f2fd";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  isSelected
                                    ? "#c8e6c9"
                                    : rowIndex % 2 === 0
                                      ? "#f5f5f5"
                                      : "#fff";
                              }}
                            >
                              <td
                                style={{
                                  padding: "10px 12px",
                                  textAlign: "center",
                                }}
                                onClick={(e) => e.stopPropagation()}
                              >
                                <input
                                  type="radio"
                                  name="mpn_row_select"
                                  checked={isSelected}
                                  onChange={() =>
                                    handleRowSelect(row, selectableTableData)
                                  }
                                  style={{
                                    cursor: "pointer",
                                    width: "16px",
                                    height: "16px",
                                    accentColor: "#3CB043",
                                  }}
                                />
                              </td>
                              {selectableTableData?.tableRowData?.map(
                                (col, colIndex) => (
                                  <td
                                    key={colIndex}
                                    style={{
                                      padding: "10px 12px",
                                      color: "#333",
                                    }}
                                  >
                                    {row[col.value] ?? "-"}
                                  </td>
                                ),
                              )}
                            </tr>
                          );
                        },
                      )}
                    </tbody>
                  </table>

                  {selectedIntMaterial && (
                    <div
                      style={{
                        marginTop: "16px",
                        padding: "10px 14px",
                        backgroundColor: "#e8f5e9",
                        borderRadius: "6px",
                        border: "1px solid #a5d6a7",
                        fontSize: "14px",
                        color: "#3CB043",
                      }}
                    >
                      ✅ Selected: <strong>{selectedIntMaterial}</strong>
                    </div>
                  )}
                </div>
              }
            />}
          </Box>
        </Paper>
      </CMainGrid>
    </ThemeProvider>
  );
};

export default MatProcessView;
